export default function RetroHeader({ cycle, onOpenSubmit, submittedCount, totalCount }) {
  return (
    <header className="page-head">
      <h1>
        {cycle.title} <em>— {cycle.cycleLabel}</em>
      </h1>
      <div className="page-head-actions">
        <button className="rtv2-submit-btn" type="button" onClick={onOpenSubmit}>
          Submit reflection
          <span className="mv2-kbd">{submittedCount}/{totalCount}</span>
        </button>
      </div>
    </header>
  );
}
